import disasterRepository from "./resources/DisasterRepository";
import chronologyRepository from "./resources/ChronologyRepository";
import facilityRepository from "./resources/FacilityRepository";
import oilRepository from "./resources/OilRepository";
import disasterInfoRepository from "./resources/DisasterInfoRepository";
import evacueeInfoRepository from "./resources/EvacueeInfoRepository";
import screenAuthorityRepository from "./resources/ScreenAuthorityRepository";
import allAreaRepository from "./resources/AllAreaRepository";
import lodineTabletsPreDistUploadRepository from "./resources/LodineTabletsPreDistUploadRepository";
import lodineDistributionRepository from "./resources/LodineDistributionRepository";
import lodinePreDistributionInfoRepository from "./resources/LodinePreDistributionInfoRepository";
import facilityEvaInfoRepository from "./resources/FacilityEvaInfoRepository";
import disasterDeliveryRepository from "./resources/DisasterDeliveryRepository";
import disasterDeliveryDetailRepository from "./resources/DisasterDeliveryDetailRepository";
import disasterStaffDeliveryRepository from "./resources/disasterStaffDeliveryRepository";
import fixedPhraseRepository from "./resources/FixedPhraseRepository";
import fileS3UploadRepository from "./resources/fileS3UploadRepository";
import fileS3UrlRepository from "./resources/fileS3UrlRepository";
import busQrCodeRepository from "./resources/BusQrCodeRepository";
import vulFacilityEvagrpRepository from "./resources/VulFacilityEvagrpRepository";
import considerationPersonUploadRepository from "./resources/ConsiderationPersonUploadRepository";
import considerationPersonInfoRepository from "./resources/ConsiderationPersonInfoRepository";
import vulFacilityRepository from "./resources/VulFacilityRepository";
import vulFacilityStatusRepository from "./resources/VulFacilityStatusRepository";
import organizeMstRepository from "./resources/OrganizeMstRepository";
import opeAuthMstRepository from "./resources/OpeAuthMstRepository";
import opeauthgpMstRepository from "./resources/OpeauthgpMstRepository";
import disasterStaffMstRepository from "./resources/DisasterStaffMstRepository";
import disasterPreventionFaRepository from "./resources/DisasterPreventionFaRepository";
import evaFacilityStatusRepository from "./resources/EvaFacilityStatusRepository";
import studentInfoRepository from "./resources/StudentInfoRepository";
import studentUploadRepository from "./resources/StudentUploadRepository";
import authorityCheckRepository from "./resources/AuthorityCheckRepository";
import tmpQrcodeUploadRepository from "./resources/TmpQrcodeUploadRepository";
import tmpQrcodeGroupRepository from "./resources/TmpQrcodeGroupRepository";
import tmpQrresidentsRepository from "./resources/TmpQrresidentsRepository";
import mapRepository from "./resources/MapRepository";
import carRepository from "./resources/CarRepository";
import carOperatorRepository from "./resources/CarOperatorRepository";
import equipmentRepository from "./resources/EquipmentRepository";
import equipmentMountManRepository from "./resources/EquipmentMountManRepository";
import systemInfoRepository from "./resources/SystemInfoRepository";
import disasterFixedphraseMstRepository from "./resources/DisasterFixedphraseMstRepository";
import infoGuideMstRepository from "./resources/InfoGuideMstRepository";
import lalertEvaInfoRepository from "./resources/LalertEvaInfoRepository";
import lalertInfoRepository from "./resources/LalertInfoRepository";
import lalertEvacuationRepository from "./resources/LalertEvacuationRepository";
import inspectionResultRepository from "./resources/InspectionResultRepository";
import carMountEquipmentRepository from "./resources/CarMountEquipmentRepository";
import equipmentDeployRepository from "./resources/EquipmentDeployRepository";
import dpndAuthInfoRepository from "./resources/DpndAuthInfoRepository";
import autonomyRepository from "./resources/AutonomyRepository";
import adjustmentSystemRepository from "./resources/AdjustmentSystemRepository";
import radiationMonitoringRepository from "./resources/RadiationMonitoringRepository";
import damageSituationRepository from "./resources/DamageSituationRepository";
import evacuationTargetRepository from "./resources/EvacuationTargetRepository";
import temporaryRegistrationRepository from "./resources/TemporaryRegistrationRepository";
import confirmationEvaRepository from "./resources/ConfirmationEvaRepository";
import evacuationTargetVulRepository from "./resources/EvacuationTargetVulRepository";
import temporaryRegistrationVulRepository from "./resources/TemporaryRegistrationVulRepository";
import confirmationVulRepository from "./resources/ConfirmationVulRepository";
import facilitySearchEvaRepository from "./resources/FacilitySearchEvaRepository";
import facilitySearchVulRepository from "./resources/FacilitySearchVulRepository";

const repositories = {
  disasterInfo: disasterInfoRepository,
  evacueeInfo: evacueeInfoRepository,
  screenAuthority: screenAuthorityRepository,
  allArea: allAreaRepository,
  lodineDistribution: lodineDistributionRepository,
  lodinePreDistributionInfo: lodinePreDistributionInfoRepository,
  lodineTabletsPreDistUpload: lodineTabletsPreDistUploadRepository,
  facilityEvaInfo: facilityEvaInfoRepository,
  disasterDelivery: disasterDeliveryRepository,
  disasterDeliveryDetail: disasterDeliveryDetailRepository,
  disasterStaffDelivery: disasterStaffDeliveryRepository,
  fixedPhrase: fixedPhraseRepository,
  fileS3Upload: fileS3UploadRepository,
  fileS3Url: fileS3UrlRepository,
  vulFacility: vulFacilityRepository,
  vulFacilityStatus: vulFacilityStatusRepository,
  facility: facilityRepository,
  organizeMst: organizeMstRepository,
  opeAuthMst: opeAuthMstRepository,
  opeauthgpMst: opeauthgpMstRepository,
  disasterStaffMst: disasterStaffMstRepository,
  disasterPreventionFa: disasterPreventionFaRepository,
  evaFacilityStatus: evaFacilityStatusRepository,
  authorityCheck: authorityCheckRepository,
  disaster: disasterRepository,
  chronologies: chronologyRepository,
  facilities: facilityRepository,
  oil: oilRepository,
  busQrCode: busQrCodeRepository,
  vulFacilityEvagrp: vulFacilityEvagrpRepository,
  considerationPersonUpload: considerationPersonUploadRepository,
  considerationPersonInfo: considerationPersonInfoRepository,
  studentInfo: studentInfoRepository,
  studentUpload: studentUploadRepository,
  tmpQrcodeUpload: tmpQrcodeUploadRepository,
  tmpQrcodeGroup: tmpQrcodeGroupRepository,
  tmpQrresidents: tmpQrresidentsRepository,
  map: mapRepository,
  car: carRepository,
  carOperator: carOperatorRepository,
  equipmentMountMan: equipmentMountManRepository,
  equipment: equipmentRepository,
  systemInfo: systemInfoRepository,
  disasterFixedphraseMst: disasterFixedphraseMstRepository,
  infoGuideMst: infoGuideMstRepository,
  lalertEvaInfo: lalertEvaInfoRepository,
  lalertInfo: lalertInfoRepository,
  lalertEvacuation: lalertEvacuationRepository,
  inspectionResult: inspectionResultRepository,
  carMountEquipment: carMountEquipmentRepository,
  equipmentDeploy: equipmentDeployRepository,
  dpndAuthInfo: dpndAuthInfoRepository,
  autonomy: autonomyRepository,
  adjustmentSystem: adjustmentSystemRepository,
  radiationMonitoring: radiationMonitoringRepository,
  damageSituation: damageSituationRepository,
  evacuationTarget: evacuationTargetRepository,
  temporaryRegistration: temporaryRegistrationRepository,
  confirmationEva: confirmationEvaRepository,
  evacuationTargetVul: evacuationTargetVulRepository,
  temporaryRegistrationVul: temporaryRegistrationVulRepository,
  confirmationVul: confirmationVulRepository,
  facilitySearchEva: facilitySearchEvaRepository,
  facilitySearchVul: facilitySearchVulRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
